import { Component, OnInit, OnDestroy } from '@angular/core';
import {TableService} from "@amlCore/services";
import { Subject } from 'rxjs';
import {IDictItemType} from "@amlCore/interfaces";
import {takeUntil} from "rxjs/operators";
import {DictionariesService} from "../service/dictionaries.service";
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ImportDictionaryComponent } from 'src/app/core';
import { Router } from '@angular/router';
import {CodeEnum} from "../../../../api/build";

@Component({
  selector: 'app-dictionary-list',
  templateUrl: './dictionary-list.component.html'
})
export class DictionaryListComponent implements OnInit, OnDestroy {

  private readonly _MODAL_CONFIG = {
    size: 'lg',
    backdrop: 'static',
    centered: true,
  } as NgbModalOptions;

  constructor(protected dictSrv: DictionariesService,
    protected tableService: TableService,
    protected modalDialog: NgbModal,
    protected router: Router
              ) {
  }

  dictionaryList: IDictItemType[] = [];

  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.dictSrv.getDictionariesList().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.dictionaryList = data;
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  viewDictionary(code: string) {
    this.router.navigate([`dictionaries/view/${code}`]);
  }

  importDictionary(code: string) {
    const modal = this.modalDialog.open(ImportDictionaryComponent, this._MODAL_CONFIG);
    const url = () => {
      switch (code) {
        case CodeEnum.Banc:
          return `/api/v1/dictionary/banc/update/by-banc`;
        case CodeEnum.Fil:
          return `/api/v1/dictionary/fil/update/by-fil`;
        case CodeEnum.CbBnkseek:
          return `/api/v1/dictionary/cb-bnkseek/update/by-ed807`;
        case CodeEnum.Barx:
          return `/api/v1/dictionary/barx/update`;
        case CodeEnum.Farx:
          return `/api/v1/dictionary/farx/update`;
        default:
          return ``;
      }
    }
    
    modal.componentInstance.url = url();
    modal.componentInstance.code = code;
  }
}


